(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog"]) return;
  try {
    
    // Builds out the swiper carousel. Slides are set to 'width: fit-content' via CSS above to balance things out.
    document.addEventListener('DOMContentLoaded', function() {
        const blogCarousel = new Swiper ('.blog-carousel', {
            slidesPerView: 4,
            breakpoints: {
                1024: {
                    enabled: false
                }
            }
        })
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-list"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const azBar = document.querySelector('[data-az-bar]');
    if (!azBar) return;

    azBar.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', e => {
        e.preventDefault();

        const id = link.getAttribute('href');
        const el = document.querySelector(id);

        if (el) el.scrollIntoView({ behavior: 'smooth' });
      })
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-header"] && !Shopify.designMode) return;
  try {
    
  class DescriptionReadmore extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('.description-readmore__content');
      this.toggle = this.querySelector('.description-readmore__toggle');

      if (!this.content || !this.toggle) return;

      this.toggle.addEventListener('click', () => this.#handleToggle());

      this.#checkOverflow();

      this.resizeObserver = new ResizeObserver(() => {
        if (!this.hasAttribute('expanded')) {
          this.#checkOverflow();
        }
      });
      this.resizeObserver.observe(this.content);
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    #checkOverflow() {
      const maxHeight = parseInt(
        getComputedStyle(this).getPropertyValue('--readmore-max-height') || '200'
      );
      const overflows = this.content.scrollHeight > maxHeight;
      overflows ? this.setAttribute('overflows', '') : this.removeAttribute('overflows');
      this.toggle.hidden = !overflows;
    }

    #handleToggle() {
      const expanding = !this.hasAttribute('expanded');

      if (expanding) {
        this.setAttribute('expanded', '');
        this.toggle.setAttribute('aria-expanded', 'true');
        this.toggle.textContent = this.toggle.dataset.less;
      } else {
        this.removeAttribute('expanded');
        this.toggle.setAttribute('aria-expanded', 'false');
        this.toggle.textContent = this.toggle.dataset.more;

        this.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }
  }

  if (!customElements.get('description-readmore')) {
    customElements.define('description-readmore', DescriptionReadmore);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collections"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const sliderContainer = document.querySelector('[data-featured-collections-slider]');
    if (!sliderContainer) return;

    const mq = window.matchMedia('(max-width: 1023px)');
    let swiperInstance = null;
    let waitingForSwiper = false;

    const paginationEl = sliderContainer.querySelector('.pagination');
    let paginationHideTimeout = null;

    const loop = sliderContainer.dataset.loop === "true";
    const slidesPerView = sliderContainer.dataset.slidesPerView;

    const cleanupStyles = () => {
      const wrapper = sliderContainer.querySelector('.swiper-wrapper');

      if (wrapper) wrapper.removeAttribute('style');

      sliderContainer.querySelectorAll('.swiper-slide').forEach((slide) => {
        slide.removeAttribute('style');
      });
    };

    const clearPaginationHideTimeout = () => {
      if (paginationHideTimeout) {
        clearTimeout(paginationHideTimeout);
        paginationHideTimeout = null;
      }
    };

    const showPagination = () => {
      if (!paginationEl) return;

      paginationEl.classList.add('opacity-100');
      clearPaginationHideTimeout();
    };

    const scheduleHidePagination = () => {
      if (!paginationEl) return;

      clearPaginationHideTimeout();

      paginationHideTimeout = setTimeout(() => {
        paginationEl.classList.remove('opacity-100');
      }, 1200);
    };

    const enableSlider = () => {
      if (swiperInstance) return;

      swiperInstance = new Swiper(sliderContainer, {
        slidesPerView: slidesPerView,
        loop: loop,
        spaceBetween: 5,
        watchOverflow: true,
        pagination: paginationEl
          ? {
              el: paginationEl,
              clickable: true,
              bulletActiveClass: '!bg-black !opacity-100'
            }
          : undefined
      });

      if (paginationEl) {
        swiperInstance.on('touchStart', showPagination);
        swiperInstance.on('sliderMove', showPagination);
        swiperInstance.on('transitionStart', showPagination);
        swiperInstance.on('transitionEnd', scheduleHidePagination);
        swiperInstance.on('touchEnd', scheduleHidePagination);
      }
    };

    const disableSlider = () => {
      if (!swiperInstance) return;

      swiperInstance.destroy(true, false);
      swiperInstance = null;
      cleanupStyles();
      clearPaginationHideTimeout();
    };

    const waitForSwiper = () => {
      if (waitingForSwiper) return;

      waitingForSwiper = true;

      const checkForSwiper = () => {
        if (typeof Swiper === 'undefined') {
          setTimeout(checkForSwiper, 100);
          return;
        }

        waitingForSwiper = false;
        if (mq.matches) enableSlider();
      };

      checkForSwiper();
    };

    const handleBreakpointChange = (state) => {
      if (state.matches) {
        if (typeof Swiper !== 'undefined') {
          enableSlider();
        } else {
          waitForSwiper();
        }
      } else {
        disableSlider();
      }
    };

    handleBreakpointChange(mq);

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', handleBreakpointChange);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(handleBreakpointChange);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const tabContainers = document.querySelectorAll('[data-tabs]');
    const carousels = {};

    // Initialize all Swiper carousels
    function initCarousels() {
      const displayMode = document.querySelector('[data-display-mode]')?.dataset.displayMode;

      if (displayMode === 'carousel' && typeof Swiper !== 'undefined') {
        const carouselElements = document.querySelectorAll('.product-carousel');

        carouselElements.forEach(carousel => {
          const carouselId = carousel.dataset.carouselId;

          // Skip if already initialized
          if (carousels[carouselId]) return;

          // Get the wrapper element for navigation buttons
          const wrapper = carousel.closest('.product-carousel-wrapper');

          // Initialize Swiper for all carousels (visible and hidden)
          carousels[carouselId] = new Swiper(carousel, {
            slidesPerView: 2.2,
            spaceBetween: 8,
            observer: true,
            observeParents: true,
            navigation: {
              nextEl: wrapper.querySelector('.swiper-button-next-custom'),
              prevEl: wrapper.querySelector('.swiper-button-prev-custom'),
              disabledClass: 'opacity-30 cursor-not-allowed hover:border-gray-300',
            },
            pagination: {
              el: carousel.querySelector('.swiper-pagination'),
              clickable: true,
            },
            breakpoints: {
              640: {
                slidesPerView: 2.333,
                spaceBetween: 8
              },
              768: {
                slidesPerView: 3.333,
                spaceBetween: 12
              },
              1024: {
                slidesPerView: 4,
                spaceBetween: 12
              }
            },
            on: {
              init: function(swiper) {
                updateNavigationState(swiper, wrapper);
              },
              slideChange: function(swiper) {
                updateNavigationState(swiper, wrapper);
              },
            }
          });

          // Function to update navigation button states
          function updateNavigationState(swiper, wrapper) {
            const prevButton = wrapper.querySelector('.swiper-button-prev-custom');
            const nextButton = wrapper.querySelector('.swiper-button-next-custom');

            if (prevButton) {
              if (swiper.isBeginning) {
                prevButton.classList.add('opacity-30', 'cursor-not-allowed');
                prevButton.classList.remove('hover:border-gray-900', 'cursor-pointer');
              } else {
                prevButton.classList.remove('opacity-30', 'cursor-not-allowed');
                prevButton.classList.add('hover:border-gray-900', 'cursor-pointer');
              }
            }

            if (nextButton) {
              if (swiper.isEnd) {
                nextButton.classList.add('opacity-30', 'cursor-not-allowed');
                nextButton.classList.remove('hover:border-gray-900', 'cursor-pointer');
              } else {
                nextButton.classList.remove('opacity-30', 'cursor-not-allowed');
                nextButton.classList.add('hover:border-gray-900', 'cursor-pointer');
              }
            }
          }
        });
      }
    }

    tabContainers.forEach(container => {
      const triggers = container.querySelectorAll('[data-tab-trigger]');
      const panels = container.querySelectorAll('[data-tab-panel]');

      function activateTab(trigger, index) {
        triggers.forEach(t => {
          t.setAttribute('aria-selected', 'false');
          t.setAttribute('tabindex', '-1');
          t.classList.add('text-gray-light');
          t.classList.remove('text-denim-dark');
        });

        panels.forEach(p => {
          p.classList.add('hidden');
        });

        trigger.setAttribute('aria-selected', 'true');
        trigger.setAttribute('tabindex', '0');
        trigger.classList.add('text-denim-dark');
        trigger.classList.remove('text-gray-light');

        const targetPanel = document.getElementById(trigger.getAttribute('aria-controls'));
        if (targetPanel) {
          targetPanel.classList.remove('hidden');

          // Update carousel when tab becomes visible
          const carousel = targetPanel.querySelector('.product-carousel');
          if (carousel) {
            const carouselId = carousel.dataset.carouselId;
            if (carousels[carouselId]) {
              // Force update the carousel dimensions
              setTimeout(() => {
                carousels[carouselId].update();
                carousels[carouselId].updateSlides();
                carousels[carouselId].updateProgress();
                carousels[carouselId].updateSlidesClasses();
              }, 0);
            }
          }
        }
      }

      triggers.forEach((trigger, index) => {
        trigger.addEventListener('click', function() {
          activateTab(trigger, index);
        });

        trigger.addEventListener('keydown', function(e) {
          let newIndex = index;

          if (e.key === 'ArrowRight') {
            newIndex = (index + 1) % triggers.length;
          } else if (e.key === 'ArrowLeft') {
            newIndex = (index - 1 + triggers.length) % triggers.length;
          } else if (e.key === 'Home') {
            newIndex = 0;
          } else if (e.key === 'End') {
            newIndex = triggers.length - 1;
          } else {
            return;
          }

          e.preventDefault();
          triggers[newIndex].click();
          triggers[newIndex].focus();
        });
      });
    });

    // Wait for Swiper to be available
    function waitForSwiper() {
      if (typeof Swiper !== 'undefined') {
        initCarousels();
      } else {
        setTimeout(waitForSwiper, 100);
      }
    }

    waitForSwiper();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fit-finder-questionnaire"] && !Shopify.designMode) return;
  try {
    
  class FitFinderQuestionnaire extends HTMLElement {
    constructor() {
      super();
      this.config = null;
      this.form = null;
      this.questions = [];
      this.boostContainer = null;
      this.resultsWrapper = null;
      this.isFirstSubmission = true;
      this.boostObserver = null;
      this.submitLoadingTimeout = null;
      this.submitOverlay = null;
      this.hasNudgedSizeTabs = false;
    }

    connectedCallback() {
      this.#loadConfig();
      this.#bindElements();
      this.#initializeGender();
      this.#initializeQuestions();
      this.#initializeWaistTabs();
      this.#attachEventListeners();
      this.#setupBoostIntegration();
      this.#checkInitialState();
    }

    disconnectedCallback() {
      this.boostObserver?.disconnect();
    }

    #loadConfig() {
      const configEl = this.querySelector('[data-fit-finder-config]');
      if (!configEl) return;
      try {
        this.config = JSON.parse(configEl.textContent);
      } catch (e) {
        console.error('Failed to parse fit finder config:', e);
      }
    }

    #bindElements() {
      this.form = this.querySelector('[data-fit-finder-form]');
      this.questions = [...this.querySelectorAll('.fit-finder-question')];
    }

    #initializeGender() {
      const genderInputs = this.querySelectorAll('input[name="gender"]');
      for (const input of genderInputs) {
        input.addEventListener('change', () => {
          this.#updateFitMedia(input.value);
          if (this.questions[0]) {
            this.#openQuestion(this.questions[0]);
          }
        });
      }
    }

    #updateFitMedia(genderValue) {
      const genderKey = genderValue === this.config?.genderValues?.mens ? 'mens' : 'womens';
      const mediaEls = this.querySelectorAll('.fit-finder-fit-card__media');

      for (const media of mediaEls) {
        const image = media.dataset[`${genderKey}Image`];
        const video = media.dataset[`${genderKey}Video`];

        const imgEl = media.querySelector('img');
        const videoEl = media.querySelector('video');

        if (imgEl && image) {
          imgEl.src = image;
        }

        if (videoEl) {
          if (image) videoEl.poster = image;
          if (video) {
            videoEl.src = video;
            videoEl.load();
          }
        }
      }
    }

    #initializeWaistTabs() {
      const sizeQuestion = this.querySelector('[data-question-type="size"]');
      if (!sizeQuestion) return;

      const tabs = sizeQuestion.querySelectorAll('[data-waist-tab]');
      const panels = sizeQuestion.querySelectorAll('[data-size-panel]');

      for (const tab of tabs) {
        tab.addEventListener('click', () => {
          const waist = tab.dataset.waistTab;

          // Update tab active state
          for (const t of tabs) {
            t.classList.toggle('fit-finder-size__waist-tab--active', t === tab);
          }

          // Show corresponding panel
          for (const p of panels) {
            p.classList.toggle('fit-finder-size__panel--active', p.dataset.sizePanel === waist);
          }

          // Scroll active tab into view
          tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        });
      }
    }

    #initializeQuestions() {
      for (const question of this.questions) {
        const header = question.querySelector('.fit-finder-question__header');
        const nextBtn = question.querySelector('[data-next-question]');
        const clearBtn = question.querySelector('[data-clear-selection]');
        const inputs = question.querySelectorAll('input[type="checkbox"]');

        header?.addEventListener('click', (e) => {
          if (e.target.closest('[data-clear-selection]')) return;
          this.#toggleQuestion(question);
        });

        nextBtn?.addEventListener('click', () => this.#advanceToNextQuestion(question));

        clearBtn?.addEventListener('click', (e) => {
          e.stopPropagation();
          this.#clearQuestionSelections(question);
        });

        for (const input of inputs) {
          input.addEventListener('change', () => this.#updateSelectionCount(question));
        }
      }
    }

    #toggleQuestion(question) {
      const isOpen = question.classList.contains('fit-finder-question--open');

      for (const q of this.questions) {
        this.#closeQuestion(q);
      }

      if (!isOpen) {
        this.#openQuestion(question);
      }
    }

    #openQuestion(question) {
      const header = question.querySelector('.fit-finder-question__header');
      const content = question.querySelector('.fit-finder-question__content');

      question.classList.add('fit-finder-question--open');
      header?.setAttribute('aria-expanded', 'true');
      content?.removeAttribute('hidden');

      if (question.dataset.questionType === 'size') {
        this.#nudgeSizeTabs();
      }
    }

    #nudgeSizeTabs() {
      if (this.hasNudgedSizeTabs) return;
      const sizeQuestion = this.querySelector('[data-question-type="size"]');
      const tabs = sizeQuestion?.querySelector('[data-waist-tabs]');
      if (!tabs) return;

      const prefersReducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
      if (prefersReducedMotion) return;

      this.hasNudgedSizeTabs = true;

      window.setTimeout(() => {
        const startLeft = tabs.scrollLeft;
        tabs.scrollTo({ left: startLeft + 24, behavior: 'smooth' });

        window.setTimeout(() => {
          tabs.scrollTo({ left: startLeft, behavior: 'smooth' });
        }, 250);
      }, 500);
    }

    #closeQuestion(question) {
      const header = question.querySelector('.fit-finder-question__header');
      const content = question.querySelector('.fit-finder-question__content');

      question.classList.remove('fit-finder-question--open');
      header?.setAttribute('aria-expanded', 'false');
      content?.setAttribute('hidden', '');
    }

    #advanceToNextQuestion(currentQuestion) {
      const currentIndex = this.questions.indexOf(currentQuestion);
      const nextQuestion = this.questions[currentIndex + 1];

      this.#closeQuestion(currentQuestion);

      if (nextQuestion) {
        this.#openQuestion(nextQuestion);
        const topOffset = 24;
        const nextTop = nextQuestion.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: Math.max(0, nextTop - topOffset), behavior: 'smooth' });
      }
    }

    #clearQuestionSelections(question) {
      const inputs = question.querySelectorAll('input[type="checkbox"]:checked');
      for (const input of inputs) {
        input.checked = false;
      }
      this.#updateSelectionCount(question);
    }

    #updateSelectionCount(question) {
      // Count all checked checkboxes across all panels (for size question)
      const checkedInputs = question.querySelectorAll('input[type="checkbox"]:checked');
      const countEl = question.querySelector('[data-selection-count]');
      const clearBtn = question.querySelector('[data-clear-selection]');
      const checkIcon = question.querySelector('[data-selection-check]');

      const count = checkedInputs.length;

      if (countEl) {
        countEl.textContent = count > 0 ? `${count} Selected` : '0 Selected';
      }

      if (clearBtn) {
        clearBtn.hidden = count === 0;
      }

      if (checkIcon) {
        checkIcon.hidden = count === 0;
      }
    }

    #attachEventListeners() {
      this.form?.addEventListener('submit', this.#handleSubmit.bind(this));

      const editBtn = this.querySelector('[data-fit-finder-edit]');
      editBtn?.addEventListener('click', () => this.#expandQuestionnaire());

      window.addEventListener('popstate', () => {
        this.#handlePopState();
      });
    }

    #handleSubmit(event) {
      event.preventDefault();
      const selections = this.#gatherSelections();
      this.#saveToStorage(selections);

      // Build new URL with filter params
      const url = new URL(window.location);

      // Clear existing pf_ params
      [...url.searchParams.keys()]
        .filter(k => k.startsWith('pf_'))
        .forEach(k => url.searchParams.delete(k));

      // Add new filter params
      const params = this.#buildFilterParams(selections);
      for (const [key, value] of params) {
        url.searchParams.append(key, value);
      }

      // Check filter mode setting
      const filterMode = this.config?.filterMode || 'ajax';
      console.log('[FitFinder] Filter mode:', filterMode);

      if (filterMode === 'reload') {
        console.log('[FitFinder] Using reload mode - navigating to new URL');
        this.#showSkeletonLoading();
        this.#collapseQuestionnaire();
        this.#scrollToEditButton();
        sessionStorage.setItem('fit_finder_scroll_to_results', '1');
        window.location.href = url.toString();
        return;
      }

      console.log('[FitFinder] AJAX mode - attempting filter refresh without reload');

      const hasCurrentFilters = [...new URLSearchParams(window.location.search).keys()]
        .some(k => k.startsWith('pf_'));

      this.#showSubmitLoading();

      this.#collapseQuestionnaire();
      this.#scrollToEditButton();
      history.pushState({ fitFinder: true }, '', url.toString());
      this.#triggerBoostRefresh();
    }

    #gatherSelections() {
      const formData = new FormData(this.form);

      return {
        gender: formData.get('gender'),
        fits: formData.getAll('fit[]').filter(v => v !== ''),
        sizes: formData.getAll('size[]'),
        timestamp: Date.now()
      };
    }

    #buildFilterParams(selections) {
      const params = new URLSearchParams();
      const { filterKeys } = this.config;

      if (selections.gender) {
        params.append(filterKeys.gender, selections.gender);
      }

      if (selections.fits?.length) {
        for (const fit of selections.fits) {
          params.append(filterKeys.fit, fit);
        }
      }

      if (selections.sizes?.length) {
        for (const size of selections.sizes) {
          params.append(filterKeys.size, size);
        }
      }

      return params;
    }

    #saveToStorage(selections) {
      if (!this.config?.storageKey) return;

      const expiry = Date.now() + (this.config.storageDays * 24 * 60 * 60 * 1000);
      try {
        localStorage.setItem(this.config.storageKey, JSON.stringify({
          ...selections,
          expiry
        }));
      } catch (e) {
        console.warn('Failed to save fit finder selections:', e);
      }
    }

    #restoreFromStorage() {
      if (!this.config?.storageKey) return null;

      try {
        const stored = localStorage.getItem(this.config.storageKey);
        if (!stored) return null;

        const data = JSON.parse(stored);

        if (data.expiry < Date.now()) {
          localStorage.removeItem(this.config.storageKey);
          return null;
        }

        return data;
      } catch (e) {
        console.warn('Failed to restore fit finder selections:', e);
        return null;
      }
    }

    #populateFormFromUrl() {
      const params = new URLSearchParams(window.location.search);
      const { filterKeys } = this.config;

      const gender = params.get(filterKeys.gender);
      const fits = params.getAll(filterKeys.fit);
      const sizes = params.getAll(filterKeys.size);

      this.#populateForm({ gender, fits, sizes });
    }

    #populateForm(data) {
      // Clear all checkboxes
      this.form?.querySelectorAll('input[type="checkbox"]').forEach(input => {
        input.checked = false;
      });

      // Set gender radio and update fit media
      if (data.gender) {
        const genderInput = this.form?.querySelector(`input[name="gender"][value="${CSS.escape(data.gender)}"]`);
        if (genderInput) genderInput.checked = true;
        this.#updateFitMedia(data.gender);
      }

      // Set fit checkboxes
      if (data.fits?.length) {
        for (const fit of data.fits) {
          const input = this.form?.querySelector(`input[name="fit[]"][value="${CSS.escape(fit)}"]`);
          if (input) input.checked = true;
        }
      }

      // Set size checkboxes and activate the correct waist tab
      if (data.sizes?.length) {
        for (const size of data.sizes) {
          const input = this.form?.querySelector(`input[name="size[]"][value="${CSS.escape(size)}"]`);
          if (input) input.checked = true;
        }

        // Activate waist tab for first selected size
        const firstSize = data.sizes[0];
        const waistMatch = firstSize?.match(/W(\d+)/);
        if (waistMatch) {
          const waistTab = this.querySelector(`[data-waist-tab="${waistMatch[1]}"]`);
          if (waistTab) waistTab.click();
        }
      }

      // Update selection counts
      for (const question of this.questions) {
        this.#updateSelectionCount(question);
      }
    }

    #checkInitialState() {
      console.log('[FitFinder] Checking initial state...');
      const hasFilters = [...new URLSearchParams(window.location.search).keys()]
        .some(k => k.startsWith('pf_'));

      console.log('[FitFinder] Has URL filters:', hasFilters);

      if (hasFilters) {
        console.log('[FitFinder] Filters present - showing results, collapsing questionnaire');
        this.#collapseQuestionnaire();
        this.#populateFormFromUrl();
        this.#showBoostProductList();
        if (this.resultsWrapper) {
          this.resultsWrapper.classList.add('fit-finder-results--visible');
        }
        this.isFirstSubmission = false;

        if (sessionStorage.getItem('fit_finder_scroll_to_results')) {
          sessionStorage.removeItem('fit_finder_scroll_to_results');
          requestAnimationFrame(() => this.#scrollToResults());
        }
      } else {
        console.log('[FitFinder] No filters - hiding product grid, showing questionnaire');
        this.#expandQuestionnaire();
        this.#hideBoostProductList();

        const storedData = this.#restoreFromStorage();
        if (storedData) {
          console.log('[FitFinder] Restored selections from storage');
          this.#populateForm(storedData);
        }

        // Only auto-open first accordion if a gender is already selected (e.g. from storage)
        const hasGender = this.form?.querySelector('input[name="gender"]:checked');
        if (hasGender && this.questions[0]) {
          this.#openQuestion(this.questions[0]);
        }
      }
    }

    #handlePopState() {
      const hasFilters = [...new URLSearchParams(window.location.search).keys()]
        .some(k => k.startsWith('pf_'));

      if (hasFilters) {
        this.#populateFormFromUrl();
        this.#collapseQuestionnaire();
      } else {
        this.#expandQuestionnaire();
        if (this.resultsWrapper) {
          this.resultsWrapper.classList.remove('fit-finder-results--visible');
        }
      }
    }

    #collapseQuestionnaire() {
      this.classList.add('fit-finder-questionnaire--collapsed');
    }

    #expandQuestionnaire() {
      this.classList.remove('fit-finder-questionnaire--collapsed');

      // Hide the product grid so resubmission reloads/re-reveals it
      this.#hideBoostProductList();
      if (this.resultsWrapper) {
        this.resultsWrapper.classList.remove('fit-finder-results--visible');
      }

      // Open first accordion only if a gender is already selected (e.g. editing)
      const hasGender = this.form?.querySelector('input[name="gender"]:checked');
      if (hasGender && this.questions[0]) {
        this.#openQuestion(this.questions[0]);
      }

      this.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    #setupBoostIntegration() {
      console.log('[FitFinder] Setting up Boost integration...');

      this.boostProductList = document.querySelector('.boost-sd__filter-product-list');
      this.boostAppBlock = document.querySelector('[data-block-handle="filter-product-list-ssr"]');
      this.boostContainer = this.boostProductList || document.querySelector('.boost-sd__product-list, [data-total-product], .boost-pfs-filter-products');

      this.resultsWrapper = this.boostAppBlock || document.querySelector('[data-fit-finder-results]');

      if (!this.resultsWrapper && this.boostContainer) {
        const section = this.boostContainer.closest('section, .shopify-section');
        if (section) {
          this.resultsWrapper = section;
          section.setAttribute('data-fit-finder-results', '');
        }
      }

      if (this.resultsWrapper) {
        this.resultsWrapper.setAttribute('data-fit-finder-results', '');
      }

      if (this.boostContainer) {
        this.boostObserver = new MutationObserver((mutations) => {
          const hasProducts = this.boostContainer.querySelector('.boost-sd__product-item');
          if (hasProducts) {
            this.#onBoostRenderComplete();
          }
        });
      }

      if (window.boostWidgetIntegration?.regisCustomization) {
        const fitFinderElement = this;
        window.fitFinderAfterRender = function fitFinderAfterRender() {
          fitFinderElement.dispatchEvent(new CustomEvent('boost:render-complete'));
        };
        try {
          window.boostWidgetIntegration.regisCustomization(window.fitFinderAfterRender, 'filter');
        } catch (e) {
          console.error('[FitFinder] Error registering with boostWidgetIntegration:', e);
        }

        this.addEventListener('boost:render-complete', () => {
          this.#onBoostRenderComplete();
        });
      }
    }

    #showBoostProductList() {
      if (this.boostProductList) {
        this.boostProductList.style.display = '';
        this.boostProductList.classList.remove('fit-finder-hidden');
      }

      if (this.boostContainer && this.boostContainer !== this.boostProductList) {
        this.boostContainer.style.display = '';
      }

      if (this.resultsWrapper) {
        this.resultsWrapper.classList.add('fit-finder-results--visible');
      }
    }

    #hideBoostProductList() {
      if (this.boostProductList) {
        //this.boostProductList.style.display = 'none';
        this.boostProductList.classList.add('fit-finder-hidden');
      }
    }

    #onBoostRenderComplete() {
      console.log('[FitFinder] Boost render complete detected!');
      clearTimeout(this.fallbackTimeout);
      this.boostObserver?.disconnect();
      this.#hideLoading();

      if (this.resultsWrapper) {
        this.resultsWrapper.classList.add('fit-finder-results--visible');
      }

      this.#scrollToResults();
    }

    #scrollToResults() {
      const scrollTarget =
        this.boostProductList ||
        this.boostAppBlock ||
        this.resultsWrapper ||
        document.querySelector('.boost-sd__product-list');

      if (scrollTarget) {
        requestAnimationFrame(() => {
          scrollTarget.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        });
      }
    }

    #scrollToEditButton() {
      const editContainer = this.querySelector('[data-fit-finder-edit-container]');
      if (!editContainer) return;

      const topOffset = 48;
      requestAnimationFrame(() => {
        const targetTop = editContainer.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: Math.max(0, targetTop - topOffset), behavior: 'smooth' });
      });
    }

    #showSkeletonLoading() {
      if (!this.resultsWrapper) return;

      this.resultsWrapper.classList.add('fit-finder-results--visible');
      this.resultsWrapper.classList.add('fit-finder-results--loading');

      const skeletonHtml = this.#createSkeletonHtml();

      let skeletonContainer = this.resultsWrapper.querySelector('.fit-finder-skeleton');
      if (!skeletonContainer) {
        skeletonContainer = document.createElement('div');
        skeletonContainer.className = 'fit-finder-skeleton';
        this.resultsWrapper.insertBefore(skeletonContainer, this.resultsWrapper.firstChild);
      }
      skeletonContainer.innerHTML = skeletonHtml;
      skeletonContainer.hidden = false;

      this.#hideBoostProductList();
      this.resultsWrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    #createSkeletonHtml() {
      const cardCount = 8;
      let cards = '';

      for (let i = 0; i < cardCount; i++) {
        cards += `
          <div class="fit-finder-skeleton__card">
            <div class="fit-finder-skeleton__image"></div>
            <div class="fit-finder-skeleton__content">
              <div class="fit-finder-skeleton__title"></div>
              <div class="fit-finder-skeleton__subtitle"></div>
              <div class="fit-finder-skeleton__price"></div>
            </div>
          </div>
        `;
      }

      return `
        <div class="fit-finder-skeleton__header">
          <div class="fit-finder-skeleton__spinner"></div>
          <span>Finding your perfect fit...</span>
        </div>
        <div class="fit-finder-skeleton__grid">
          ${cards}
        </div>
      `;
    }

    #showLoadingOverlay() {
      if (!this.resultsWrapper) return;

      this.resultsWrapper.classList.add('fit-finder-results--reloading');

      if (this.boostContainer) {
        this.boostContainer.classList.add('boost-sd--loading');
      }
    }

    #ensureResultsWrapper() {
      if (this.resultsWrapper && document.contains(this.resultsWrapper)) return;

      this.boostProductList = document.querySelector('.boost-sd__filter-product-list');
      this.boostAppBlock = document.querySelector('[data-block-handle="filter-product-list-ssr"]');
      this.boostContainer = this.boostProductList || document.querySelector('.boost-sd__product-list, [data-total-product], .boost-pfs-filter-products');
      this.resultsWrapper = this.boostAppBlock || document.querySelector('[data-fit-finder-results]');

      if (!this.resultsWrapper && this.boostContainer) {
        const section = this.boostContainer.closest('section, .shopify-section');
        if (section) {
          this.resultsWrapper = section;
          section.setAttribute('data-fit-finder-results', '');
        }
      }

      if (this.resultsWrapper) {
        this.resultsWrapper.setAttribute('data-fit-finder-results', '');
      }
    }

    #showSubmitLoading() {
      this.#ensureResultsWrapper();
      if (!this.resultsWrapper) return;

      if (this.submitLoadingTimeout) {
        clearTimeout(this.submitLoadingTimeout);
      }

      this.resultsWrapper.classList.add('fit-finder-results--visible');
      this.resultsWrapper.classList.remove('fit-finder-results--loading');
      this.resultsWrapper.classList.remove('fit-finder-results--reloading');

      const skeleton = this.resultsWrapper.querySelector('.fit-finder-skeleton');
      if (skeleton) {
        skeleton.hidden = true;
      }

      this.#showBoostProductList();

      if (!this.submitOverlay) {
        this.submitOverlay = document.querySelector('[data-fit-finder-results-overlay]');
      }

      if (!this.submitOverlay) return;

      requestAnimationFrame(() => {
        this.submitOverlay?.classList.add('fit-finder-results-overlay--visible');
      });

      this.submitLoadingTimeout = setTimeout(() => {
        if (!this.submitOverlay) return;
        this.submitOverlay.classList.remove('fit-finder-results-overlay--visible');

        window.setTimeout(() => {
          this.submitOverlay?.removeAttribute('style');
        }, 600);
      }, 1000);
    }

    #hideLoading() {
      if (!this.resultsWrapper) return;

      this.resultsWrapper.classList.remove('fit-finder-results--loading');
      this.resultsWrapper.classList.remove('fit-finder-results--reloading');
      this.resultsWrapper.classList.remove('fit-finder-results--submit-loading');

      const skeleton = this.resultsWrapper.querySelector('.fit-finder-skeleton');
      if (skeleton) {
        skeleton.hidden = true;
      }

      this.#showBoostProductList();

      if (this.boostContainer) {
        this.boostContainer.classList.remove('boost-sd--loading');
      }
    }

    #triggerBoostRefresh() {
      console.log('[FitFinder] Triggering Boost refresh...');

      if (this.boostObserver && this.boostContainer) {
        this.boostObserver.observe(this.boostContainer, {
          childList: true,
          subtree: true
        });
      }

      window.dispatchEvent(new PopStateEvent('popstate', { state: { fitFinder: true } }));

      if (window.boostPFS?.FilterApi?.onChangeFilter) {
        try {
          window.boostPFS.FilterApi.onChangeFilter();
        } catch (e) {
          console.error('[FitFinder] Error calling boostPFS.FilterApi.onChangeFilter:', e);
        }
      } else if (window.BoostPFS?.FilterApi?.onChangeFilter) {
        try {
          window.BoostPFS.FilterApi.onChangeFilter();
        } catch (e) {
          console.error('[FitFinder] Error calling BoostPFS.FilterApi.onChangeFilter:', e);
        }
      } else if (window.boostSDFilter?.refresh) {
        try {
          window.boostSDFilter.refresh();
        } catch (e) {
          console.error('[FitFinder] Error calling boostSDFilter.refresh:', e);
        }
      }

      window.dispatchEvent(new HashChangeEvent('hashchange'));
      window.dispatchEvent(new CustomEvent('boost:filter:change', {
        detail: { source: 'fit-finder' }
      }));

      this.#showBoostProductList();
      this.#pollForBoostRender();
    }

    #pollForBoostRender() {
      let attempts = 0;
      const maxAttempts = 50;

      const checkInterval = setInterval(() => {
        attempts++;
        const productItems = document.querySelectorAll('.boost-sd__product-item');
        const hasProducts = productItems.length > 0;
        const boostLoading = document.querySelector('.boost-sd--loading, .boost-sd__loading');

        if (hasProducts && !boostLoading) {
          clearInterval(checkInterval);
          this.#onBoostRenderComplete();
          return;
        }

        if (attempts >= maxAttempts) {
          clearInterval(checkInterval);
          this.#onBoostRenderComplete();
        }
      }, 100);
    }
  }

  customElements.define('fit-finder-questionnaire', FitFinderQuestionnaire);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(() => {
  const trigger = document.querySelector('#search-button');
  const overlay = document.querySelector('[data-search-overlay]');
  if (!trigger || !overlay) return;

  const nav = overlay.parentElement?.querySelector('[data-header-mega-nav]');
  const backdrop = document.querySelector('[data-search-backdrop]');
  const input = overlay.querySelector('[data-search-input]');
  const clearBtn = overlay.querySelector('[data-search-clear]');
  const closeControls = overlay.querySelectorAll('[data-search-overlay-close]');
  let previousFocus = null;

  const setState = isOpen => {
    overlay.dataset.searchOverlayState = isOpen ? 'open' : 'closed';
    overlay.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    if (nav) nav.style.display = isOpen ? 'none' : '';
    if (backdrop) backdrop.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
  };

  const handleKeydown = event => {
    if (event.key === 'Escape') closeOverlay();
  };

  const openOverlay = () => {
    if (overlay.dataset.searchOverlayState === 'open') return;
    previousFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    setState(true);

    requestAnimationFrame(() => {
      input?.focus({ preventScroll: true });
    });

    document.addEventListener('keydown', handleKeydown);
  };

  const closeOverlay = () => {
    if (overlay.dataset.searchOverlayState !== 'open') return;
    setState(false);

    document.removeEventListener('keydown', handleKeydown);

    if (previousFocus) {
      previousFocus.focus({ preventScroll: true });
    }
  };

  trigger.addEventListener('click', event => {
    event.preventDefault();
    if (window.innerWidth < 992) {
      const boostInput = document.querySelector('.boost-sd__search-bar-input');
      if (boostInput) {
        boostInput.click();
        boostInput.focus({ preventScroll: true });

        requestAnimationFrame(() => {
          boostInput.focus({ preventScroll: true });
        });
        
        return;
      }
    }
    openOverlay();
  });

  closeControls.forEach(control => {
    control.addEventListener('click', closeOverlay);
  });

  if (clearBtn) {
    clearBtn.addEventListener('click', () => {
      if (input) {
        input.value = '';
        input.focus({ preventScroll: true });
      }
    });
  }

  if (backdrop) {
    backdrop.addEventListener('click', closeOverlay);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["outfit-of-the-week"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const sectionElement = document.querySelector('[data-outfit-section]');
    if (!sectionElement) return;

    const carouselContainers = sectionElement.querySelectorAll('[data-outfit-carousel-id]');
    if (carouselContainers.length === 0) return;

    const mq = window.matchMedia('(max-width: 1023px)');
    const swiperInstances = new Map();

    const cleanupStyles = (carouselContainer) => {
      const wrapper = carouselContainer.querySelector('.swiper-wrapper');
      if (wrapper) wrapper.removeAttribute('style');
      carouselContainer.querySelectorAll('.swiper-slide').forEach((slide) => {
        slide.removeAttribute('style');
      });
    };

    const enableSlider = (carouselContainer) => {
      const carouselId = carouselContainer.dataset.outfitCarouselId;
      if (swiperInstances.has(carouselId)) return;

      const paginationWrapper = carouselContainer.closest('.outfit-card__products-wrapper');
      const paginationEl = paginationWrapper
        ? paginationWrapper.querySelector('.outfit-card__products-carousel-pagination')
        : null;

      const swiperInstance = new Swiper(carouselContainer, {
        slidesPerView: 2.333,
        spaceBetween: 8,
        slidesOffsetBefore: 18,
        slidesOffsetAfter: 18,
        watchOverflow: true,
        pagination: paginationEl
          ? {
              el: paginationEl,
              clickable: true
            }
          : undefined,
        breakpoints: {
          768: {
            slidesOffsetBefore: 27,
            slidesOffsetAfter: 27
          }
        }
      });

      swiperInstances.set(carouselId, swiperInstance);
    };

    const disableSlider = (carouselContainer) => {
      const carouselId = carouselContainer.dataset.outfitCarouselId;
      const swiperInstance = swiperInstances.get(carouselId);
      
      if (!swiperInstance) return;
      
      swiperInstance.destroy(true, false);
      swiperInstances.delete(carouselId);
      cleanupStyles(carouselContainer);
    };

    const initializeCarousels = () => {
      if (mq.matches) {
        carouselContainers.forEach((carouselContainer) => {
          enableSlider(carouselContainer);
        });
      } else {
        carouselContainers.forEach((carouselContainer) => {
          disableSlider(carouselContainer);
        });
      }
    };

    const waitForSwiper = () => {
      const checkForSwiper = () => {
        if (typeof Swiper === 'undefined') {
          setTimeout(checkForSwiper, 100);
          return;
        }
        initializeCarousels();
      };
      checkForSwiper();
    };

    const handleBreakpointChange = (state) => {
      if (state.matches) {
        if (typeof Swiper !== 'undefined') {
          carouselContainers.forEach((carouselContainer) => {
            enableSlider(carouselContainer);
          });
        } else {
          waitForSwiper();
        }
      } else {
        carouselContainers.forEach((carouselContainer) => {
          disableSlider(carouselContainer);
        });
      }
    };

    if (typeof Swiper !== 'undefined') {
      initializeCarousels();
    } else {
      waitForSwiper();
    }

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', handleBreakpointChange);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(handleBreakpointChange);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-anchored"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-anchored-page]');
    if (!root || root.dataset.ready === 'true') return;

    root.dataset.ready = 'true';

    const smoothScrollEnabled = root.dataset.smoothScroll === 'true';
    const links = Array.from(root.querySelectorAll('[data-anchor-link]'));
    const sections = Array.from(root.querySelectorAll('[data-anchor-section]'));

    if (!links.length || !sections.length) return;

    const setActive = (activeId) => {
      links.forEach((link) => {
        const isActive = link.getAttribute('href') === `#${activeId}`;
        if (isActive) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    };

    const resolveIdFromHash = () => window.location.hash.replace('#', '');
    const ids = sections.map((sectionEl) => sectionEl.id);
    const initialIdFromHash = resolveIdFromHash();
    const initialId = ids.includes(initialIdFromHash) ? initialIdFromHash : ids[0];
    setActive(initialId);

    links.forEach((link) => {
      link.addEventListener('click', (event) => {
        const targetId = link.getAttribute('href').replace('#', '');
        const target = document.getElementById(targetId);

        if (!target) return;

        if (smoothScrollEnabled) {
          event.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          history.replaceState(null, '', `#${targetId}`);
        }

        setActive(targetId);
      });
    });

    window.addEventListener('hashchange', () => {
      const hashId = resolveIdFromHash();
      if (ids.includes(hashId)) setActive(hashId);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-content"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selectors = {
      container: '[data-tabbed-content]',
      trigger: '[data-tabbed-trigger]',
      panel: '[data-tabbed-panel]'
    };

    const initialisePanel = (panel) => {
      if (panel.dataset.initialised === 'true') return;

      const collapsibleColumns = panel.querySelectorAll('[data-column-collapsible]');

      collapsibleColumns.forEach((column) => {
        setupCollapsible(column, panel);
      });

      panel.dataset.initialised = 'true';
    };

    const setupCollapsible = (column, panel) => {
      if (column.dataset.collapsibleReady === 'true') return;

      const content = column.querySelector('[data-column-content]');
      const toggle = column.querySelector('[data-more-toggle]');

      if (!content || !toggle) return;

      const checkAndSetup = (preserveState = false) => {
        const rootStyles = getComputedStyle(document.documentElement);
        const isDesktop = window.matchMedia('(min-width: 64rem)').matches;
        const threshold = parseInt(rootStyles.getPropertyValue('--tabbed-content-desktop-collapsed-height'), 10) || 450;
        const wasExpanded = column.classList.contains('is-expanded');

        if (!isDesktop) {
          // On mobile, remove collapsible behavior and show all content
          column.classList.remove('tabbed-column--collapsible', 'is-collapsed', 'is-expanded');
          toggle.hidden = true;
          return;
        }

        // Temporarily expand to get true scrollHeight
        const wasCollapsible = column.classList.contains('tabbed-column--collapsible');
        if (wasCollapsible) {
          column.classList.remove('tabbed-column--collapsible');
        }

        requestAnimationFrame(() => {
          const totalHeight = content.scrollHeight;

          if (totalHeight <= threshold) {
            column.classList.remove('tabbed-column--collapsible', 'is-collapsed', 'is-expanded');
            toggle.hidden = true;
            return;
          }

          // Re-apply collapsible class
          column.classList.add('tabbed-column--collapsible');

          // Preserve expanded state if requested (e.g., during resize)
          if (preserveState && wasExpanded) {
            column.classList.add('is-expanded');
            column.classList.remove('is-collapsed');
            toggle.textContent = toggle.dataset.lessLabel;
            toggle.setAttribute('aria-expanded', 'true');
          } else if (!preserveState) {
            column.classList.add('is-collapsed');
            column.classList.remove('is-expanded');
            toggle.textContent = toggle.dataset.moreLabel;
            toggle.setAttribute('aria-expanded', 'false');
          }

          toggle.hidden = false;
        });
      };

      // Initial setup
      checkAndSetup(false);

      // Set up toggle click handler (only needs to be done once)
      if (!toggle.dataset.listenerAdded) {
        toggle.addEventListener('click', () => {
          const expanded = column.classList.toggle('is-expanded');
          column.classList.toggle('is-collapsed', !expanded);

          toggle.textContent = expanded ? toggle.dataset.lessLabel : toggle.dataset.moreLabel;
          toggle.setAttribute('aria-expanded', String(expanded));

          panel.classList.toggle('tabbed-content__panel--expanded', expanded);
        });
        toggle.dataset.listenerAdded = 'true';
      }

      // Re-check on window resize to catch viewport changes, preserving expanded state
      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          checkAndSetup(true);
        }, 150);
      });

      column.dataset.collapsibleReady = 'true';
    };

    const initTabbedContainer = (container) => {
      if (!container || container.dataset.tabbedReady === 'true') return;

      const tablist = container.querySelector('.tabbed-content__tablist');
      const panelsContainer = container.querySelector('.tabbed-content__panels');
      const source = container.querySelector('.tabbed-content__source');

      if (!tablist || !panelsContainer) {
        container.dataset.tabbedReady = 'true';
        return;
      }

      // Move triggers/panels from source to their containers
      if (source) {
        const wrappers = Array.from(source.querySelectorAll('.tabbed-tab-wrapper'));

        wrappers.forEach(wrapper => {
          const trigger = wrapper.querySelector(selectors.trigger);
          const panel = wrapper.querySelector(selectors.panel);

          if (trigger) tablist.appendChild(trigger);
          if (panel) panelsContainer.appendChild(panel);
        });

        // Hide source after moving content
        source.hidden = true;
      }

      const triggers = Array.from(container.querySelectorAll(selectors.trigger));
      const panels = Array.from(container.querySelectorAll(selectors.panel));

      if (!triggers.length || !panels.length) {
        container.dataset.tabbedReady = 'true';
        return;
      }

      const activateTab = (index) => {
        triggers.forEach((trigger, triggerIndex) => {
          const isActive = triggerIndex === index;

          trigger.classList.toggle('tabbed-content__trigger--active', isActive);
          trigger.setAttribute('aria-selected', String(isActive));
          trigger.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        panels.forEach((panel, panelIndex) => {
          panel.classList.toggle('tabbed-content__panel--hidden', panelIndex !== index);
        });

        const activePanel = panels[index];
        if (!activePanel) return;

        initialisePanel(activePanel);
      };

      triggers.forEach((trigger, index) => {
        trigger.addEventListener('click', () => activateTab(index));

        trigger.addEventListener('keydown', (event) => {
          let newIndex = index;

          if (event.key === 'ArrowRight') {
            newIndex = (index + 1) % triggers.length;
          } else if (event.key === 'ArrowLeft') {
            newIndex = (index - 1 + triggers.length) % triggers.length;
          } else if (event.key === 'Home') {
            newIndex = 0;
          } else if (event.key === 'End') {
            newIndex = triggers.length - 1;
          } else {
            return;
          }

          event.preventDefault();
          triggers[newIndex].focus();
          triggers[newIndex].click();
        });
      });

      if (triggers.length) {
        activateTab(0);
      }

      container.dataset.tabbedReady = 'true';
    };

    const init = (root = document) => {
      const containers = Array.from(root.querySelectorAll(selectors.container));
      containers.forEach(initTabbedContainer);
    };

    // Initialize immediately when script runs (content is already in DOM)
    init();

    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', (event) => {
        init(event.target);
      });

      document.addEventListener('shopify:section:select', (event) => {
        init(event.target);
      });

      document.addEventListener('shopify:block:select', (event) => {
        const target = event.target;
        if (!target) return;

        if (target.matches(selectors.trigger)) {
          target.click();
          return;
        }

        const container = target.closest(selectors.container) || target.querySelector?.(selectors.container);
        if (container) {
          initTabbedContainer(container);
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
